import React, { FC } from 'react';
import { ForgeIcon, ForgeList, ForgeListItem } from '@tylertech/forge-react';
import { I18n } from 'common/visualizations';
import { AttachmentConfiguration } from 'common/components/ScheduleSendReport/types/attachment';
import { ATTACHMENT_ICONS } from 'common/components/ScheduleSendReport/constants';

const scope = 'shared.components.schedule_send_report.modal.attachment_section';

interface AttachmentsListProps {
  attachments: AttachmentConfiguration[];
}

const List: FC<AttachmentsListProps> = ({ attachments }) => {
  const getTitle = (attachment: AttachmentConfiguration) => {
    if (attachment.value === 'full-report') {
      return I18n.t('full_report', { scope });
    }
    return attachment.name || attachment.value;
  };

  return (
    <>
      <h1
        className="forge-typography--heading3"
        id="attachment-title-preview"
        data-testid="attachment-title-preview"
      >
        {I18n.t('title', { scope })}
      </h1>
      <ForgeList className="attachment-list-preview" data-testid="attachment-list-preview">
        {attachments.map((attachment, index) => (
          <ForgeListItem key={`${attachment.value}-${index.toString()}`}>
            <ForgeIcon name={ATTACHMENT_ICONS[attachment.type]} slot="start" />
            <div>
              <span className="forge-typography--body2">{getTitle(attachment)}</span>
              <br />
              <span className="forge-typography--body1">
                {I18n.t('format', { scope })}:{' '}
                {I18n.t(`shared.explore_grid.export_dataset_modal.${attachment.format}`)}
              </span>
            </div>
          </ForgeListItem>
        ))}
      </ForgeList>
    </>
  );
};

export default List;
